import { PRIORITY_STYLE, STATUS_STYLE, scoreColor } from "./constants";

export function ScoreBadge({ value, testId }) {
  const c = scoreColor(value || 0);
  return (
    <span className="badge mono" style={{ color: c, borderColor: c + "66", background: c + "1a" }} data-testid={testId} title="Response-likelihood score (0–100)">
      {value ?? 0}
    </span>
  );
}

export function PriorityBadge({ value }) {
  const s = PRIORITY_STYLE[value] || PRIORITY_STYLE.Low;
  return (
    <span className="badge" style={{ color: s.color, background: s.bg, borderColor: s.border }} data-testid={`priority-badge-${value?.toLowerCase()}`}>
      <span className="dot" style={{ background: s.dot }} />
      {value}
    </span>
  );
}

export function StatusBadge({ value }) {
  const s = STATUS_STYLE[value] || STATUS_STYLE["Not Sent"];
  return (
    <span className="badge" style={{ color: s.color, background: s.bg, borderColor: s.border }}>
      {value}
    </span>
  );
}

export function StatusSelect({ value, onChange, options, testId }) {
  const s = STATUS_STYLE[value] || { color: "#94A3B8", bg: "rgba(100,116,139,0.15)", border: "rgba(100,116,139,0.3)" };
  return (
    <select
      data-testid={testId}
      className="select select-inline"
      value={value}
      onClick={(e) => e.stopPropagation()}
      onChange={(e) => onChange(e.target.value)}
      style={{ color: s.color, background: s.bg, borderColor: s.border }}
    >
      {options.map((o) => (
        <option key={o} value={o} style={{ color: "#f8fafc", background: "#171a26" }}>{o}</option>
      ))}
    </select>
  );
}

const EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

export function DraftBadge({ contact, testId }) {
  const hasEmail = EMAIL_RE.test((contact.email || "").trim());
  let label, color, bg;
  if (contact.lastReply) { label = "Replied"; color = "#10b981"; bg = "rgba(16,185,129,0.12)"; }
  else if (contact.outreachStatus !== "Not Sent") { label = "Sent"; color = "#06b6d4"; bg = "rgba(6,182,212,0.12)"; }
  else if (contact.gmailDraftId) { label = "Draft in Gmail"; color = "#f59e0b"; bg = "rgba(245,158,11,0.14)"; }
  else if (!hasEmail) { label = "No email route"; color = "#64748b"; bg = "rgba(100,116,139,0.14)"; }
  else { label = "Needs draft"; color = "#f87171"; bg = "rgba(248,113,113,0.12)"; }
  return (
    <span className="badge" style={{ color, borderColor: color, background: bg }} data-testid={testId} title={label === "Draft in Gmail" ? "Open Gmail → Drafts to review and send" : undefined}>
      <span className="dot" style={{ background: color }} /> {label}
    </span>
  );
}
